import { Reveal } from "./Reveal";

export const Statement = () => {
  return (
    <section data-testid="statement-section" className="bg-[#EDE9E0] py-24 sm:py-36">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="font-display text-3xl sm:text-5xl lg:text-[54px] text-[#111513] leading-[1.18] text-balance">
            Sometimes the most valuable thing we can offer isn&rsquo;t an offer.{" "}
            <span className="italic text-[#A77A50]">It&rsquo;s information.</span>
          </p>
          <p className="mt-8 text-base sm:text-lg text-[#5C665F] leading-relaxed max-w-xl">
            Good decisions start with understanding. If a conversation leaves you knowing more about your property
            than you did before, it was worth having — whether or not it ever involves us.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
